import { createSlice } from "@reduxjs/toolkit";
import { getUploadLimits } from "./thunk";
import { getTemplateCreatives } from "../campaigns/thunk";

export const initialState = {
  uploadedFiles: [],
  uploadLimits: null,
}

const uploadSlice = createSlice({
  name: 'Upload',
  initialState,
  reducers: {
    setUploadedFiles(state, action) {
      state.uploadedFiles = action.payload;
    },
    setUploadLimits(state, action) {
      state.uploadLimits = action.payload;
    },
    resetUploadedState(state) {
      state.uploadedFiles = [];
      state.uploadLimits = null;
    }
  },
  extraReducers: builder => {
    builder.addCase(getUploadLimits.fulfilled, (state, action) => {
      state.uploadLimits = action.payload;
    });
    builder.addCase(getTemplateCreatives.fulfilled, (state, action) => {
      state.uploadedFiles = action.payload;
    });
  }
});

export const {
  setUploadedFiles,
  setUploadLimits,
  resetUploadedState
} = uploadSlice.actions;

export default uploadSlice.reducer;